var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"messages",staticClass:"messages px-3"},[_vm._l((_vm.mappedMessages),function(message){return _c('MessageRow',{key:message.ts,attrs:{"message":message}})}),_c('PulseLoader',{attrs:{"loading":_vm.loading,"color":"#5a686e"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }